import React from 'react';
import { Tooltip } from 'antd';
import SubmitButton from '../../SubmitButton';
import { useFormikContext } from 'formik';
import {
  useAssetTranslation,
  useHasAssetPermissions,
} from '@mss/mss-component-library';

type Props = {
  shouldTest: boolean;
  testHasErrors: boolean;
};

export default function SaveButton({ shouldTest, testHasErrors }: Props) {
  const { errors, touched } = useFormikContext<any>();
  const permissions = useHasAssetPermissions();
  const { t } = useAssetTranslation();

  return (
    <Tooltip
      title={t(
        `asset:You don't seem to have permission to update this asset type on this site. Please contact your administrator for help.`
      )}
      placement="bottom"
      overlayStyle={{
        display: !permissions.change ? undefined : 'none',
      }}
    >
      <span>
        <SubmitButton
          name="assetSettings"
          ghost={testHasErrors}
          colorOverrides={
            testHasErrors
              ? {
                  text: '#fa4654',
                  border: '#fa4654',
                }
              : undefined
          }
          disabled={
            (!testHasErrors && !!Object.keys(errors).length) ||
            !Object.keys(touched).length ||
            !permissions.change ||
            shouldTest
          }
          data-ta={testHasErrors ? 'saveFailedTestButton' : 'saveButton'}
        >
          {testHasErrors
            ? t('Save despite failed tests')
            : t('Save asset')}
        </SubmitButton>
      </span>
    </Tooltip>
  );
}
